import { APP_ID, NgModule } from '@angular/core';
import { CustomDomSharedStylesHost } from './shared_styles_host';
import { ɵSharedStylesHost, ɵDomRendererFactory2, EventManager } from '@angular/platform-browser';
import { MediaMatcher } from '@angular/cdk/layout';
import { CustomMediaMatcher } from './media-matcher';
import { CustomDomRendererFactory2 } from './ReflecxRendererFactory2';
@NgModule({
  providers: [
    { provide: 'cspMetaSelector', useValue: 'meta[name="CSP-NONCE"]' },
    { provide: ɵSharedStylesHost, useClass: CustomDomSharedStylesHost },
    {
      provide: ɵDomRendererFactory2,
      useClass: CustomDomRendererFactory2,
      deps: [EventManager, ɵSharedStylesHost, APP_ID],
    },
    { provide: MediaMatcher, useClass: CustomMediaMatcher },
  ],
})
export class InlineStylesCSPModule {}
